export default __webpack_public_path__ + "static/menu-video-3e1f55b14f7c981480fe1da0cd2ba18c.mp4";